import { createReducer } from 'typesafe-actions';

import { SurveyResource } from '@portal/common/types';

import { getSurveysAsync } from './actions';

type State = SurveyResource[] | [];

const initialState: State = [];

export default createReducer(initialState).handleAction(
    [getSurveysAsync.success],
    (state, action) => action.payload || []
);
